import FrontendException from './FrontendException';

class PostbackDataMapperException extends FrontendException {
  constructor(message) {
    super(message);
    this.name = 'PostbackDataMapperException';
  }
}

export default PostbackDataMapperException;
